import { path } from 'd3'
import component from 'vue3-pdf'

const routes = [
  {
    path: '/',
    redirect: {name: 'login'}
  },
  {
    path: '/login',
    component: () => import('layouts/LoginLayout.vue'),
    children: [
      { path: '', name: 'login', component: () => import('pages/login/index.vue') },
      { path: 'reset', name: 'resetPassword', component: () => import('pages/login/reset/index.vue') },
    ]
  },
  {
    path: '/home',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      { path: '', name: 'home', component: () => import('pages/Index.vue') },
      { path: '/viewer', name: 'viewer', component: () => import('src/pages/viewer/index.vue') },
      { path: '/assessment', name: 'assessment', component: () => import('src/pages/assessment/index.vue') },
      { path: '/assessment-diagnostic', name: 'assessmentDiagnostic', component: () => import('src/components/assessments/ListAssessmentDiagnostic.vue') },
      { path: '/course', name: 'course', component: () => import('layouts/CourseLayout.vue') },
      { path: '/subject', name: 'subject', component: () => import('layouts/SubjectLayout.vue') },
      { path: '/workplace', name:'workplace', component: () => import('src/components/WorkplacePage.vue')},
      { path: '/user', name:'user', component: () => import('src/components/UserPage.vue')},
      // { path: '/allocation', name:'allocation', component: () => import('src/components/AllocationPage.vue')},
      { path: '/assessment-value', name:'assessmentValue', component: () => import('src/components/assessmentValue/AssessmentValue.vue')},
      { path: '/allocation-report', name:'allocationReport', component: () => import('src/components/courseAllocationReport/index.vue')},
      { path: '/mark-report', name:'markReport', component: () => import('src/components/MarkReportPerCourse.vue')},
      { path: '/mark-report-download', name:'markReportDownload', component: () => import('src/components/MarkReportDownload.vue')},
      { path: '/plugin', name:'pluginPage', component: () => import('src/components/plugin/PluginPage.vue')},
      { path: '/system', name:'system', component: () => import('src/components/systemPage/System.vue')},
      // { path: '/student-course', name: 'student_course', component: () => import('src/pages/subject/index.vue') }
    ]
  },
  {
    path: '/quiz',
    component: () => import('layouts/DetailLayout.vue'),
    children: [
      {
        path: '',
        name: 'Answer Questionnaire', component: () => import('src/pages/assessment/answerquestionnaireLMS.vue'),
        props: (route) => ({
          courseId1: route.params.courseId,
          formQuestionnaireId1: route.params.formId,
          quizData1: route.params.data})
     },
    ]
  },
  {
    path: '/input-participant/:quizIdBase64/:quizNameBase64',
    name: "Input Participant",
    component: () => import('layouts/ParticipantForQuiz.vue'),
    props: (route) => ({
      quizIdBase64: route.params.quizIdBase64,
      quizNameBase64: route.params.quizNameBase64
    }),
  },
  {
    path: '/:quizIdBase64/:quizNameBase64',
    component: () => import('layouts/LayoutQuizFromLink.vue'),
    props: (route) => ({
      quizIdBase64: route.params.quizIdBase64,
      quizNameBase64: route.params.quizNameBase64
    }),
    children: [
      {
        path: '/assessment-quiz/:quizIdBase64/:quizNameBase64',
        name: 'Assessment Quiz', component: () => import('src/components/assessments/AssessmentFromLink.vue'),
        props: (route) => ({
          quizIdBase64: route.params.quizIdBase64,
          quizNameBase64: route.params.quizNameBase64
        })
     },
    ]
  },
  {
      path: '/quiz-diagnostic-teacher',
      component: () => import('layouts/DetailLayout.vue'),
      children: [
        {
          path: '',
          name: 'Answer Questionnaire For Diagnostic Teacher', component: () => import('src/pages/assessment/answerQuestionnaireLMSDiagnosticTeacher.vue'),
          props: (route) => ({
            courseId1: route.params.courseId,
            formQuestionnaireId1: route.params.formId,
            quizData1: route.params.data})
       },
      ]
    },

  {
    path: '/:schoolId/:courseId/:subjectId/:subjectName/:statusTemplate/:isSubjectMenu',
    component: () => import('layouts/DetailLayoutVer2.vue'),
    props: (route) => ({
      courseId: route.params.courseId,
      schoolId: route.params.schoolId,
      subjectId: route.params.subjectId,
      subjectName: route.params.subjectName,
      statusTemplate: route.params.statusTemplate,
      isSubjectMenu: route.params.isSubjectMenu
    }),
    children: [
      { path: '/course-detail/:schoolId/:courseId/:subjectId/:subjectName/:statusTemplate/:isSubjectMenu', name: 'Course Detail', component: () => import('src/layouts/DetailCourse.vue'),
        props: (route) => ({
          courseId: route.params.courseId,
          schoolId: route.params.schoolId,
          subjectId: route.params.subjectId,
          subjectName: route.params.subjectName,
          statusTemplate: route.params.statusTemplate,
          isSubjectMenu: route.params.isSubjectMenu
        })
      },
      { path: '/course-allocation/:schoolId/:courseId/:subjectId/:subjectName/:statusTemplate/:isSubjectMenu', name: 'Course Allocation', component: () => import('src/layouts/DetailCourse.vue'),
        props: (route) => ({
          courseId: route.params.courseId,
          schoolId: route.params.schoolId,
          subjectId: route.params.subjectId,
          subjectName: route.params.subjectName,
          statusTemplate: route.params.statusTemplate,
          isSubjectMenu: route.params.isSubjectMenu
        })
      },
      { path: '/learning-content/:schoolId/:courseId/:subjectId/:subjectName/:statusTemplate/:isSubjectMenu', name: 'Learning Content', component: () => import('src/layouts/DetailCourse.vue'),
        props: (route) => ({
          courseId: route.params.courseId,
          schoolId: route.params.schoolId,
          subjectId: route.params.subjectId,
          subjectName: route.params.subjectName,
          statusTemplate: route.params.statusTemplate,
          isSubjectMenu: route.params.isSubjectMenu
        })
      },
      { path: '/assessment/:schoolId/:courseId/:subjectId/:subjectName/:statusTemplate/:isSubjectMenu', name: 'Assessment', component: () => import('src/layouts/DetailCourse.vue'),
        props: (route) => ({
          courseId: route.params.courseId,
          schoolId: route.params.schoolId,
          subjectId: route.params.subjectId,
          subjectName: route.params.subjectName,
          statusTemplate: route.params.statusTemplate,
          isSubjectMenu: route.params.isSubjectMenu
        })
      },
      { path: '/question-bank/:schoolId/:courseId/:subjectId/:subjectName/:statusTemplate/:isSubjectMenu', name: 'Question Bank', component: () => import('src/layouts/DetailCourse.vue'),
        props: (route) => ({
          courseId: route.params.courseId,
          schoolId: route.params.schoolId,
          subjectId: route.params.subjectId,
          subjectName: route.params.subjectName,
          statusTemplate: route.params.statusTemplate,
          isSubjectMenu: route.params.isSubjectMenu
        })
      },
    ]
  },

  {
    path: '/:schoolId/:subjectId/:subjectName/:statusTemplate/:isSubjectMenu',
    component: () => import('layouts/HeaderSubject.vue'),
    props: (route) => ({
      schoolId: route.params.schoolId,
      subjectId: route.params.subjectId,
      subjectName: route.params.subjectName,
      statusTemplate: route.params.statusTemplate,
      isSubjectMenu: route.params.isSubjectMenu
    }),
    children: [
      { path: '/learning-content/:schoolId/:subjectId/:subjectName/:statusTemplate/:isSubjectMenu', name: 'Subject Learning Content', component: () => import('src/layouts/SubjectDetail.vue'),
        props: (route) => ({
          schoolId: route.params.schoolId,
          subjectId: route.params.subjectId,
          subjectName: route.params.subjectName,
          statusTemplate: route.params.statusTemplate,
          isSubjectMenu: route.params.isSubjectMenu
        })
      },
      { path: '/question-bank/:schoolId/:subjectId/:subjectName/:statusTemplate/:isSubjectMenu', name: 'Subject Question Bank', component: () => import('src/layouts/SubjectDetail.vue'),
        props: (route) => ({
          schoolId: route.params.schoolId,
          subjectId: route.params.subjectId,
          subjectName: route.params.subjectName,
          statusTemplate: route.params.statusTemplate,
          isSubjectMenu: route.params.isSubjectMenu
        })
      },
      { path: '/subject-detail/:schoolId/:subjectId/:subjectName/:statusTemplate/:isSubjectMenu', name: 'Subject Detail', component: () => import('src/layouts/SubjectDetail.vue'),
        props: (route) => ({
          schoolId: route.params.schoolId,
          subjectId: route.params.subjectId,
          subjectName: route.params.subjectName,
          statusTemplate: route.params.statusTemplate,
          isSubjectMenu: route.params.isSubjectMenu
        })
      },
    ]
  },

  {
    path: '/question/:schoolId/:subjectId/:statusTemplate/:data',
    component: () => import('layouts/LayoutQuestionBank.vue'),
    props: (route) => ({
      schoolId: route.params.schoolId,
      subjectId: route.params.subjectId,
      data: route.params.data,
      statusTemplate: route.params.statusTemplate
    }),
    children: [
      { path: '',
        name: 'Question', component: () => import('src/components/questionAssessments/QuestionList.vue'),
        props: (route) => ({
          schoolId: route.params.schoolId,
          subjectId: route.params.subjectId,
          data: route.params.data
        })
      },
    ]
  },
  {
    path: '/answer-template/:schoolId/:subjectId',
    component: () => import('layouts/LayoutAnswerTemplate.vue'),
    props: (route) => ({
      schoolId: route.params.schoolId,
      subjectId: route.params.subjectId,
    }),
    children: [
      { path: '',
        name: 'Answer Template', component: () => import('src/components/questionAssessments/AnswerTemplate.vue'),
        props: (route) => ({
          schoolId: route.params.schoolId,
          subjectId: route.params.subjectId,
        })
      },
    ]
  },
  {
    path: '/input-quiz/:schoolId/:courseId/:subjectId/:subjectName/:statusTemplate/:isSubjectMenu/:isNew/:quizId',
    component: () => import('layouts/LayoutQuiz.vue'),
    props: (route) => ({
      courseId: route.params.courseId,
      schoolId: route.params.schoolId,
      subjectId: route.params.subjectId,
      subjectName: route.params.subjectName,
      statusTemplate: route.params.statusTemplate,
      isSubjectMenu: route.params.isSubjectMenu,
      isNew: route.params.isNew,
      quizId: route.params.quizId

    }),
    children: [
      { path: '',
        name: 'Input Quiz', component: () => import('src/components/assessments/AssessmentQuiz.vue'),
        props: (route) => ({
          courseId: route.params.courseId,
          schoolId: route.params.schoolId,
          subjectId: route.params.subjectId,
          subjectName: route.params.subjectName,
          statusTemplate: route.params.statusTemplate,
          isSubjectMenu: route.params.isSubjectMenu,
          isNew: route.params.isNew,
          quizId: route.params.quizId
        })
      },
    ]
  },
  {
    path:'/quiz-preview/:schoolId/:courseId/:subjectId/:quizId',
    name: 'Quiz Preview',
    component: () => import('src/components/assessments/FormQuestionnairePreview.vue'),
    props: (route) => ({
      courseId: route.params.courseId,
      schoolId: route.params.schoolId,
      subjectId: route.params.subjectId,
      quizId: route.params.quizId
    })
  },
  {
    path: '/input-user/:isNew/:userId',
    component: () => import('layouts/LayoutUser.vue'),
    props: (route) => ({
      userId: route.params.userId,
      isNew: route.params.isNew
    }),
    children: [
      { path: '',
        name: 'Input User', component: () => import('src/components/InputUser.vue'),
        props: (route) => ({
          userId: route.params.userId,
          isNew: route.params.isNew
        })
      },
    ]
  },
  {
    path: '/home',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      { path: '/kalender', name: 'kalender', component: () => import('src/pages/kalender/index.vue') },
    ]
  },
  {
    path: '/home',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      { path: '/student-course', name: 'student_course', component: () => import('src/pages/subject/index.vue') },
    ]
  },
  {
    path: '/student-course/:data',
    component: () => import('layouts/DrawerRighLayout.vue'),
    props: (route) => ({
      data: route.params.data,
    }),
    children: [
      { path: '', name: 'home_course', component: () => import('pages/subject/homeCourse.vue'),
      props: (route) => ({
        data: route.params.data,
      })
      },
    ]
  },
  {
    path: '/contentSubjectDetail',
    component: () => import('layouts/DetailLayout.vue'),
    children: [
      {
        path: '', name: 'content_subject_detail', component: () => import('pages/subject/contentSubjectDetail.vue'),
        props: (route) => ({
          data: route.params.data,
        })
      }
    ]
  },
  {
    path: '/contentSubject/:unitId?',
    component: () => import('layouts/LayoutContentSubject.vue'),
    props: (route) => ({
      data: route.params.data,
    }),
    children: [
      { path: '', name: 'content_subject', component: () => import('pages/subject/contentSubject.vue'),
      props: (route) => ({
        data: route.params.data,
        unitId: route.params.unitId,
      })
    },
    ]
  },
  {
    path: '/assessmentSubject',
    component: () => import('layouts/LayoutContentSubject.vue'),
    props: (route) => ({
      data: route.params.data,
    }),
    children:[
      { path: '', name: 'assessment_subject', component: () => import('pages/subject/assessmentSubject.vue'),
      props: (route) => ({
        data: route.params.data,
      })
     }
    ]
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/Error404.vue')
  }
]

export default routes
